// Project Specific
$(document).ready(function() {

    $('.img-slick-slider').slick({
        dots: false,
        arrows: true,
        infinite: false,
        speed: 300,
        slidesToShow: 1,
        slidesToScroll: 1,
        rows: 0
    });
});
